import * as React from "react";
import { observable, computed, action } from "mobx";
import { observer, inject } from "mobx-react";
import * as UiStore from "../States/AreaUiInfo";
import { AreaSplitter } from "./AreaSplitter";


@inject('areaUiInfo')
@observer
export class AreaAside extends React.Component<UiStore.IAreaUiInfo, {}> {

	@computed get areaAsideGridClass() {
		return !this.props.noCollapse && this.props.areaUiInfo.isCollapsed ? "area-grid__aside is--collapsed" : "area-grid__aside";
	}

	@computed get areaAsideStyle(): React.CSSProperties {
		let width = !this.props.noCollapse && this.props.areaUiInfo.isCollapsed ? UiStore.asideCollapsedWidth : this.props.areaUiInfo.asideWidth;
		return { width: width }
	}

	render() {
		return <div className={this.areaAsideGridClass} style={this.areaAsideStyle}>
			<AreaSplitter noCollapse={this.props.noCollapse} />
			{this.props.children}
		</div>;
	}
}
